module.exports = __webpack_public_path__ + "static/media/sunbeam-photography-C2QbMA_nHYE-unsplash.e6f8e33b.jpg";